import { FiltriOrdiniMTM } from '@/store';
import { FinderBase } from './FinderBase';
import dayjs from 'dayjs';

export class FinderOrdiniMTM extends FinderBase
{
    public fornitore: string = "";
    public nominativoCliente: string = "";
    public idCliente: string = "";
    public numeroOrdine: string = "";
    public stato: string = "";
    public dataConsegnaDa?: Date;
    public dataConsegnaA?: Date;
    public rigaDataConsegnaFornitoreDa?: Date;
    public rigaDataConsegnaFornitoreA?: Date;
    public rigaDataChiusuraConsegnaDa?: Date;
    public rigaDataChiusuraConsegnaA?: Date;
    public filtroStagioni?: String[];
    public filtroModelli?: String[];

    //#endregion

    public constructor(fornitore: string, pagina?: number) {
        super();

        this.fornitore = fornitore;
        if(pagina) {
            this.numeroPagina = pagina;
        }
    }

    public ApplicaFiltriOrdini(filtri: FiltriOrdiniMTM) {
        this.nominativoCliente = filtri.nominativoCliente;
        this.idCliente = filtri.idCliente;
        this.numeroOrdine = filtri.numeroOrdine;
        this.stato = filtri.stato;
        this.filtroModelli = filtri.filtroModelli;
        this.filtroStagioni = filtri.filtroStagioni;

        let dataDa = dayjs(filtri.dataConsegnaDa, { utc: true });
        if(dataDa.isValid()) {
            this.dataConsegnaDa = dataDa.toDate();
        }

        let dataA = dayjs(filtri.dataConsegnaA, { utc: true });
        if(dataA.isValid()) {
            this.dataConsegnaA = dataA.toDate();
        }

        let rigaDataChiusuraConsegnaDa = dayjs(filtri.rigaDataChiusuraConsegnaDa, { utc: true });
        if(rigaDataChiusuraConsegnaDa.isValid()) {
            this.rigaDataChiusuraConsegnaDa = rigaDataChiusuraConsegnaDa.toDate();
        }

        let rigaDataChiusuraConsegnaA = dayjs(filtri.rigaDataChiusuraConsegnaA, { utc: true });
        if(rigaDataChiusuraConsegnaA.isValid()) {
            this.rigaDataChiusuraConsegnaA = rigaDataChiusuraConsegnaA.toDate();
        }

        let rigaDataConsegnaFornitoreDa = dayjs(filtri.rigaDataConsegnaFornitoreDa, { utc: true });
        if(rigaDataConsegnaFornitoreDa.isValid()) {
            this.rigaDataConsegnaFornitoreDa = rigaDataConsegnaFornitoreDa.toDate();
        }
        let rigaDataConsegnaFornitoreA = dayjs(filtri.rigaDataConsegnaFornitoreA, { utc: true });
        if(rigaDataConsegnaFornitoreA.isValid()) {
            this.rigaDataConsegnaFornitoreA = rigaDataConsegnaFornitoreA.toDate();
        }

    }
}